import '@otrocheyon/scss/app-front-page.scss';
import Utils from '@otrocheyon/js/services/utils';
import Form from '@otrocheyon/js/services/form';
import Slider from '@otrocheyon/js/services/slider';
import Menu from '@otrocheyon/js/services/menu';
import Instagram from '@otrocheyon/js/services/instagram';

document.addEventListener( "DOMContentLoaded", function () {

    // Utils
    Utils.click();
    Utils.autoNaving();
    Utils.google_translate();
    Utils.bootstrap();
    Utils.initializeProgressBar();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.initializeAgendaLink();
    Utils.intializeRevealTitle();
    Utils.initializeCarnetThumbnail();
    Utils.initializeBackToTop();

    // Form
    Form.newsletter_email();

    // Instagram
    Instagram.ajax_instagram();

    new Menu();

    // Slider
    Slider.hero();
    Slider.slider_strate_voyage();
    Slider.slider_strate_highlight();
    Slider.slider_agenda();
    Slider.slider_post();
})
